import { render, staticRenderFns } from "./purchase_order_list.vue?vue&type=template&id=f6b18bd4&scoped=true"
import script from "./purchase_order_list.vue?vue&type=script&lang=js"
export * from "./purchase_order_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b18bd4",
  null
  
)

export default component.exports